import React from "react";
import { Route, Switch, withRouter } from "react-router-dom";

// Routes
// Sub Pages
import {
  ExerciseDetailsComponent,
  ExerciseListPage,
  ExercisesAddComponent,
  ExercisesEditComponent,
} from "../components/Exercises";

export const ExercisesComponent: React.FC = () => {
  return (
    <div id="Exercises">
      <Switch>
        <Route exact path="/exercises" component={withRouter(ExerciseListPage)} />
        <Route exact path="/exercises/add" component={withRouter(ExercisesAddComponent)} />
        <Route exact path="/exercises/edit/:id" component={withRouter(ExercisesEditComponent)} />
        <Route exact path="/exercises/:id" component={withRouter(ExerciseDetailsComponent)} />
      </Switch>
    </div>
  );
};

export default ExercisesComponent;
